
import React, {  useMemo, useState, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";

import { NotificationManager } from "react-notifications";
import { Nav, Button, ModalFooter, TabContent, TabPane, Modal, ModalBody, Table, ModalHeader } from 'reactstrap';

import { Page }from "components/common";
import { ApiClient, AppsClient} from "services";
import LoadingMsg from "components/common/LoadingMsg";
import { ExSpan } from "pages/Xero/Settings/TaxReturnsDetail";
import { KeyField } from "../Zatca/ZatcaDetails";
import BackButton from "components/refactoring/BackButton";
import { Link, useHistory } from 'react-router-dom';
import { AddNewButton } from "components/common/Tables";

const s = {
  td: {
    className: "text-left",
  },
  th: {
    className: "text-left",
    style:{fontSize: "1.3em"}
  },
  table: {
    className: "mt-5",
    style: {
      border: '1px solid #ccc',
      borderRadius: '5px',
      margin: '0 auto',
    }
  },
  navTab: {
    style: { cursor: 'pointer', fontSize: '1.05em', padding: 10 }
  }
};

const AvailableApps = ({}) => {
   
    const api = ApiClient()
  
    const [data, setData] = useState();
  
    const [loading, setLoading] = useState(false);
  
    const { t } = useTranslation()

    const [deleting, setDeleting] = useState(false);
  
    const fetchData = async () => {
      setLoading(true)
      try {
        const response = await api.get("portal");
        const data = response.data;
        setData(data);
        setLoading(false)
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false)
      }
    };
    
    useEffect(() => {
      fetchData();
    }, []);

    const [activeTab, setActiveTab] = useState(0);

    const toggleTab = (tabIndex) => {
      if (activeTab !== tabIndex) {
        setActiveTab(tabIndex);
      }
    };

    const client = ApiClient()

    const history = useHistory()

    const handleDelete = (id, name) => {

      if (id === undefined) {
        NotificationManager.error("The ID is invalid, Please check the details and try again")
        return
      }

      setDeleting(true)
   
      client.delete(`portal/${id}`)
        .then(response => {
          console.log("Server response:", response.data);
          NotificationManager.success(t(`Successfully deleted the Application - ${name}`));
          fetchData()
          setDeleting(false)
          setActiveTab(0)
        })
        .catch(error => {
          console.error("Error:", error);
          if (error.response && error.response.data) {
            const errors = error.response.data;
            Object.entries(errors).forEach(([key, value]) => {
              const errorMessage = `${key.charAt(0).toUpperCase() + key.slice(1)} - ${value}`;
              NotificationManager.error(errorMessage);
              setDeleting(false)
            });
          } else {
            NotificationManager.error(t("An error occurred while deleting"));
            setDeleting(false)
          }
        });
    };

    const editLink = (id) => {
      history.push(`/auth/register/${id}`)
    };


    const [isOpen, setIsOpen] = useState(false);
    const [delName, setName] = useState();
    const [delID, setID] = useState();

    const toggleConfirm = (id, name) => {
      setIsOpen(!isOpen)
      setName(name)
      setID(id)
    };


    return (
      <Page title={t("Connected Applications")} className="inv-tabs nw-list">
      <BackButton/>
      <AddNewButton resource="Application" fullURL='/auth/register' className="mb-2  mt-3" />
      {loading ? (
        <LoadingMsg />
      ) : (
      <>
      <Nav tabs className="nw-tabs2 inv-tabs">
        {data?.map((item, index) => (
          <div
           key={index}
           onClick={() => toggleTab(index)}
           className={`${activeTab === index ? 'active-tabNum ' : ''}m-1`}
           style={s.navTab.style}
          >
            <Trans>{item.name}</Trans>
          </div>
        ))}
      </Nav>
      <TabContent activeTab={activeTab}>
        {data?.map((item, index) => (
          <TabPane key={index} tabId={index}>
            <Table {...s.table}>
              <thead>
                <tr>
                  <th {...s.th}><Trans>{item.name} Application Details</Trans></th>
                  <th />
                  <th className="text-right">
                    <Button onClick={() => editLink(item.id)}><span className="fa fa-edit" style={{fontSize: "15px"}}></span></Button>
                    {deleting ? 
                      <Button color="danger" disabled><span className="fa fa-spinner fa-spin" style={{fontSize: "15px"}}/></Button>:
                      <Button color="danger" onClick={() => toggleConfirm(item.id, item.name)}><span className="fa fa-trash" style={{fontSize: "15px"}}/></Button>
                    }
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <ExSpan label="User" value={item.user} />
                  <ExSpan label="Name" value={item.name} />
                  <ExSpan label="Type" value={item.type} />
                </tr>
                <tr>
                  <ExSpan label="Login URL" value={item.login_url} />
                  <ExSpan label="Client Type" value={item.client_type} />
                  <ExSpan label="Authorization Grant Type" value={item.authorization_grant_type} />
                </tr>
                <tr>
                  <ExSpan label="Authorization" value={item.skip_authorization ? "Skipped" : "Authorized"} />
                  <ExSpan label="Redirect URIs" value={item.redirect_uris} />
                </tr>
              </tbody>
            </Table>
            <div className="container border mt-3 mb-4">
              <div className="row my-3">
                <KeyField label="Client ID" value={item.client_id} />
                <KeyField label="Client Secret" value={item.client_secret} />
              </div>
            </div>
          </TabPane>
        ))}
      </TabContent>
      </>
      )}
      <Modal isOpen={isOpen} toggle={toggleConfirm}>
        <ModalHeader><Trans>Deleting {delName}</Trans></ModalHeader>
        <ModalBody>
          <Trans>Are you sure you want to delete this Application?</Trans>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => { toggleConfirm(); handleDelete(delID, delName); }}><Trans>Confirm</Trans></Button>
          <Button color="secondary" onClick={toggleConfirm}><Trans>Cancel</Trans></Button>
        </ModalFooter>
      </Modal>
      </Page>
    );
  };

  export default AvailableApps;